import React from 'react';
import { IconChevronRight } from '@noths/polaris-client-ribbons-design-system';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { Icon } from '@noths/polaris-design-system-core-components';

import type { DeliverySummaryViewModel } from 'src/adapters/storeToUI/adaptDeliveryToSummary';
import { DeliveryEventMessage } from 'src/components/atoms/DeliveryEventMessage/DeliveryEventMessage';
import { FreePartnerDeliveryMessage } from 'src/components/atoms/FreePartnerDeliveryMessage/FreePartnerDeliveryMessage';
import * as styles from './DeliverySummary.styles';

export interface DeliverySummaryProps extends DeliverySummaryViewModel {
  href: string;
  onLinkClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

const WANT_IT_SOONER_PREFIX = 'Want it sooner? You can get it ';
const FREE_PRICE_LABEL = 'FREE';

const Chevron = () => (
  <IconChevronRight
    color={`var(${themeVariables.colors.content.default})`}
    height={16}
    width={16}
  />
);

export const DeliverySummary = ({
  content,
  deliveryEventName,
  freePartnerDelivery,
  href,
  onLinkClick = () => {},
}: DeliverySummaryProps) => {
  return (
    <div>
      {deliveryEventName && <DeliveryEventMessage eventName={deliveryEventName} />}
      <a css={styles.deliverySummary} href={href} onClick={onLinkClick}>
        {content === null ? (
          <span css={styles.primaryLine}>
            Delivery &amp; returns info <Chevron />
          </span>
        ) : (
          <>
            {content.orderByText && <small css={styles.orderBy}>{content.orderByText}</small>}
            <b css={styles.primaryLine}>
              <Icon name="delivery" size="md" />
              <span>
                {content.primary.prefix}
                {content.primary.dateTime ? (
                  <time dateTime={content.primary.dateTime}>{content.primary.value}</time>
                ) : (
                  content.primary.value
                )}{' '}
                (
                <span
                  css={content.primary.price === FREE_PRICE_LABEL ? styles.freePrice : styles.price}
                >
                  {content.primary.price}
                </span>
                )
              </span>
              {content.secondary === null && <Chevron />}
            </b>
            {content.secondary && (
              <small css={styles.secondaryLine}>
                <span>
                  {WANT_IT_SOONER_PREFIX}
                  {content.secondary.dateTime ? (
                    <time dateTime={content.secondary.dateTime}>{content.secondary.value}</time>
                  ) : (
                    content.secondary.value
                  )}{' '}
                  ({content.secondary.price})
                </span>
                <Chevron />
              </small>
            )}
          </>
        )}
      </a>
      {freePartnerDelivery && (
        <FreePartnerDeliveryMessage
          formattedThreshold={freePartnerDelivery.formattedThreshold}
          partnerName={freePartnerDelivery.partnerName}
        />
      )}
    </div>
  );
};
